import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { declOfNum } from "../../lib/utils";
import { photoUrl } from "../../config";
import BookingServicePeriodPopup from "./BookingServicePeriodPopup";
import TooltipWithShortDelay from "../ui/TooltipWithShortDelay";

function BookingServiceItem({
  booking,
  service,
  _id,
  datein = null,
  dateout = null,
  name,
  add_hour,
  add_hour_price,
  service_price,
  anounce,
  description,
  photo,
  photo_updated,
  service_count,
  service_is_personal_time,
  service_personal_time,
  service_personal_time_value,
  service_time,
  service_time_from,
  service_time_to,
  service_time_from_time,
  service_time_to_time,
  service_technical_break_interval,
  pay_type,
  pay_target,
  service_type,
  max_services,
  terms_of_payment,
  terms_of_payment_prepaid_sum,
  terms_of_payment_prepaid_target,
  terms_of_payment_prepaid_type,
  cancel_reservation_activation_time,
  cancel_reservation_activation_time_type,
  cancel_reservation_fee,
  cancel_reservation_fee_amount,
  cancel_reservation_fee_amount_type,
  cancel_reservation_fee_time,
  cancel_reservation_type,
  selected,
  addServiceHandler,
  days,
}) {
  const [count, setCount] = useState(selected?.count || 0);
  const [openSelectPeriod, setOpenSelectPeriod] = useState(false);

  useEffect(() => {
    setCount(selected?.count || 0);
  }, [selected]);

  const onChangeCount = (actual_count, period = {}) => {
    addServiceHandler({
      id: _id,
      add_id: booking.getAddId(service),
      add_hour,
      add_hour_price,
      name,
      price: service_price,
      count: actual_count,
      sum: service_price * actual_count,
      terms_of_payment,
      terms_of_payment_prepaid_sum,
      terms_of_payment_prepaid_target,
      terms_of_payment_prepaid_type,
      cancel_reservation_activation_time,
      cancel_reservation_activation_time_type,
      cancel_reservation_fee,
      cancel_reservation_fee_amount,
      cancel_reservation_fee_amount_type,
      cancel_reservation_fee_time,
      cancel_reservation_type,
      pay_type,
      pay_target,
      service_type,
      service_count,
      service_is_personal_time,
      service_personal_time,
      service_personal_time_value,
      ...period,
    });
  };

  const incHandler = () => {
    if (service_is_personal_time == 2) {
      setOpenSelectPeriod(true);
    } else {
      if (count < max_services) {
        onChangeCount(count + 1);
        setCount((prev) => prev + 1);
      }
    }
  };
  const decHandler = () => {
    onChangeCount(count - 1);
    setCount((prev) => prev - 1);
  };

  return (
    <div
      className={classNames("bookingServiceCard dfsp", { active: count > 0 })}
    >
      <div className="bookingServiceCard__photo dfa">
        {photo ? (
          <img
            src={`${photoUrl}/services/${_id}.jpg?v=${photo_updated}`}
            alt="photo"
          />
        ) : (
          "нет фото"
        )}
      </div>
      <div className="bookingServiceCard__body dfsp">
        <div className="bookingServiceCard__header dfsp">
          <div>
            <div className="bookingServiceCard__title">{name}</div>
            <div className="bookingServiceCard__options">{anounce}</div>
          </div>
          <div className="bookingServiceCard__price">
            <b>{service_price} ₽</b>
            <span className="bookingServiceCard__unit">
              {/* {service_type === "service" && <>за услугу</>} */}
              {service_type === "product" && <>за штуку</>}
              {service_type === "service" && (
                <>
                  {pay_type === "hour" &&
                    pay_target === "service" &&
                    declOfNum(parseInt(service_count), [
                      "час",
                      "часа",
                      "часов",
                    ])}
                  {pay_type === "minute" &&
                    pay_target === "service" &&
                    declOfNum(parseInt(service_count), [
                      "минута",
                      "минуты",
                      "минут",
                    ])}
                  {pay_type === "hour" &&
                    pay_target === "guest" &&
                    declOfNum(parseInt(service_count), [
                      "гость",
                      "гостя",
                      "гостей",
                    ])}
                  {pay_type === "fixed" && pay_target === "service" && (
                    <>за {service_count}</>
                  )}
                  {pay_type === "fixed" &&
                    pay_target === "guest" &&
                    declOfNum(parseInt(service_count), [
                      "гость",
                      "гостя",
                      "гостей",
                    ])}
                </>
              )}
            </span>
          </div>
        </div>
        <div className="bookingServiceCard__add dfsp dfa">
          <div>
            {description && (
              // <TooltipReact id={_id} content={description} click={true}>
              //   <span className="details">Подробнее &gt;</span>
              // </TooltipReact>
              <TooltipWithShortDelay content={description}>
                <span className="details">Подробнее &gt;</span>
              </TooltipWithShortDelay>
            )}
          </div>
          <div className="dfa">
            {/* {service_is_personal_time != 2 && count > 0 && (
              <>
                <button className="circle" onClick={decHandler}>
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#6E6F71" />
                    <line
                      x1="6.55566"
                      y1="12.3334"
                      x2="19.0001"
                      y2="12.3334"
                      stroke="white"
                      strokeWidth="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
                <span className="count">{count}</span>
                <button
                  className="circle"
                  onClick={incHandler}
                  disabled={count >= max_services}
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#6E6F71" />
                    <path
                      d="M12.7778 5.55554V20"
                      stroke="white"
                      strokeWidth="2"
                      stroke-linecap="round"
                    />
                    <line
                      x1="6.55566"
                      y1="12.3334"
                      x2="19.0001"
                      y2="12.3334"
                      stroke="white"
                      strokeWidth="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
              </>
            )} */}
            {count < max_services && (
              <button onClick={incHandler}>Добавить</button>
            )}
          </div>
        </div>
      </div>
      <BookingServicePeriodPopup
        name={name}
        booking={booking}
        isOpened={openSelectPeriod}
        setIsOpened={setOpenSelectPeriod}
        onChangeCount={onChangeCount}
        service_id={_id}
        add_hour={add_hour}
        service_count={service_count}
        service_time={service_time}
        service_time_from={service_time_from}
        service_time_to={service_time_to}
        service_time_from_time={service_time_from_time}
        service_time_to_time={service_time_to_time}
        service_personal_time={service_personal_time}
        service_personal_time_value={service_personal_time_value}
        service_technical_break_interval={service_technical_break_interval}
        pay_type={pay_type}
        days={days}
        def_date={datein}
      />
    </div>
  );
}

export default BookingServiceItem;

// {service_is_personal_time == 2 && count > 0 && (
//   <div className="bookingServiceCard__period">
//     <div className="bookingServiceCard__periodT">
//       <span>{dateToMonth(selected.date, true)}</span>
//       <span>
//         {addZero(selected.hour)}:{addZero(selected.minute)} -{" "}
//         {addZero(selected.h_end_p)}:{addZero(selected.m_end_p)}
//       </span>
//     </div>
//     <button className="circle" onClick={decHandler}>
//       <svg
//         width="25"
//         height="25"
//         viewBox="0 0 25 25"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <circle cx="12.5" cy="12.5" r="12.5" fill="#A5A5A5" />
//         <line
//           x1="6.55566"
//           y1="12.3334"
//           x2="19.0001"
//           y2="12.3334"
//           stroke="white"
//           strokeWidth="2"
//           stroke-linecap="round"
//         />
//       </svg>
//     </button>
//   </div>
// )}
